module.exports = __webpack_public_path__ + "static/media/HL14.26b83dad.jpg";